import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { isLeftClickEvent, isModifiedEvent } from 'helpers/EventHelpers';

class MartyLink extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { onClick, target, to } = this.props;

    if (onClick) {
      onClick(e);
    }

    if (!isLeftClickEvent(e) || isModifiedEvent(e) || e.defaultPrevented || target) {
      return;
    }

    e.preventDefault();
    this.context.router.pushPreserveAppRoot(to);
  }

  render() {
    // generating an object without onClick since Link won't accept it in props
    // eslint-disable-next-line no-unused-vars
    const { onClick, ...rest } = this.props;
    return <Link onClick={this.handleClick} {...rest}/>;
  }
}

MartyLink.contextTypes = {
  router: PropTypes.object.isRequired
};

MartyLink.propTypes = {
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default MartyLink;
